module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": "is-success",
      "message": "This username is available"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "value": "iwantmytreasure",
      "password-reveal": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Message"
    }
  }, [_c('b-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b53c9f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/examples/ExSimple.vue
// module id = 1097
// module chunks = 13 126